<div class="landing-page-container">
  @if (carrierData?.companyLogo) {
    <div class="carrier-logo-box">
      <img [src]="carrierData.companyLogo" alt="Carrier Logo" />
    </div>
  } @else {
    <div class="ellipse-icon">
      <img src="/assets/images/fleetoperate.png" alt="FleetOperate Logo" />
    </div>
  }


  @if (carrierData) {
    <div class="headline">
      Apply to <strong>{{ carrierData?.companyName }}</strong><br />
      through FleetOperate.
    </div>
  }

  @if (verificationRequired) {
    <section class="verification-section custom-width" aria-labelledby="verification-title">
      <div class="verification-prompt" role="alert">
        <mat-icon aria-hidden="true">mark_email_unread</mat-icon>
        <div>
          <h2 id="verification-title">Verify your email</h2>
          <p>{{ errorMessage }}</p>
        </div>
      </div>

      <button
        class="resend-verification-button"
        mat-raised-button
        color="primary"
        type="button"
        [disabled]="resendVerificationLoading || resendVerificationCooldown"
        (click)="resendVerificationEmail()"
        data-test="resend-verification-button">
        <mat-icon aria-hidden="true">{{ resendVerificationLoading ? 'hourglass_empty' : 'send' }}</mat-icon>
        <span>{{ resendVerificationLoading ? 'Sending...' : 'Resend verification email' }}</span>
      </button>
    </section>
  } @else if (errorMessage) {
    <mat-error  class="error" data-test="form-error-message">
      {{ errorMessage }}
    </mat-error>
  }

  <form [formGroup]="form" #signinForm="ngForm" (ngSubmit)="onSubmit(signinForm)" class="login-form">
    <mat-form-field appearance="outline" floatLabel="always" class="custom-width">
      <mat-label>Email</mat-label>
      <input type="email" #email inputmode="email" matInput formControlName="email"
        data-test="email-form-field" />

      @if (form.get('email')?.touched && form.get('email')?.invalid) {
        <mat-error data-test="email-error-field">
          {{ getEmailErrorMessage() }}
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" floatLabel="always" class="custom-width">
      <mat-hint align="start">at least 8 characters</mat-hint>
      <mat-label>Password</mat-label>
      <input matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password"
        data-test="password-form-field" />
      <mat-icon matSuffix (click)="hidePassword = !hidePassword" data-test="password-visibility-button">{{
        hidePassword ? 'visibility' : 'visibility_off'
      }}</mat-icon>
      @if (form.get('password')?.touched && form.get('password')?.invalid) {
        <mat-error data-test="password-error-field">
          {{ getPasswordErrorMessage() }}
        </mat-error>
      }
    </mat-form-field>

    <button class="signin-button custom-width margin-bottom" mat-raised-button color="primary" type="submit"
      [disabled]="form.pristine || !form.valid || loading" data-test="login-button">
      Sign In
    </button>
  </form>

  <div class="signup-text">
    Don’t have an account? <a class="sign-up-link" (click)="onNavigateToSignUp()">Sign up</a>
  </div>

  <div class="footer">
    <span>Powered by</span>
    <img src="/assets/images/fleetoperate-logo.png" alt="FleetOperate Logo" />
  </div>
</div>